import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function HowToPlay({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ background: "rgba(0,0,0,0.7)" }}
          data-testid="howto-modal"
        >
          <motion.div
            initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95, y: 10 }}
            className="glass max-w-2xl w-full p-8 rounded-3xl scroll-y"
            style={{ maxHeight: "85vh" }}
          >
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-display text-3xl font-black">How to Play</h2>
              <button className="btn-ghost" onClick={onClose} data-testid="howto-close">Close</button>
            </div>
            <div className="space-y-4 text-white/85" style={{ fontSize: 14, lineHeight: 1.6 }}>
              <div>
                <span className="label-eyebrow">Goal</span>
                <p className="mt-1">Be the first to line up <b>4 cards of your color</b> in a row — horizontal, vertical, or diagonal.</p>
              </div>
              <div>
                <span className="label-eyebrow">Setup</span>
                <p className="mt-1">4 players, each with a unique color/suit and a 19-card deck (18 normal + 1 special). Cards have a <b>power</b> from 1 to 9.</p>
              </div>
              <div>
                <span className="label-eyebrow">Your Turn</span>
                <p className="mt-1">Draw the top card from your deck. Then place it on the 6×6 board:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li><b>Empty cell</b> adjacent (8-way) to any existing card.</li>
                  <li><b>On top</b> of any card if your <b>power is greater</b> than the top card's power. Color doesn't matter.</li>
                </ul>
              </div>
              <div>
                <span className="label-eyebrow">Special Cards</span>
                <p className="mt-1">Each deck has one special. When drawn, you must use it:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li><b>▲ Power Up</b> — boost your top card by +3 power.</li>
                  <li><b>▼ Power Down</b> — drop an opponent's top card by 3 power.</li>
                  <li><b>✦ Blocker</b> — lock an empty adjacent cell forever.</li>
                  <li><b>↔ Color Switcher</b> — flip an opponent's top card to your color.</li>
                </ul>
              </div>
              <div>
                <span className="label-eyebrow">Win Detection</span>
                <p className="mt-1">Only the <b>top</b> card of each cell counts toward lines. Win = 4 in a row of your color.</p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
